/**
 * Stylized owl glyph for the Diagon Alley header.
 * Hand-traced minimal SVG; no external dependencies.
 */
export function OwlLogo({ size = 32, className }: { size?: number; className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 64 64"
      className={className}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="owl-grad" x1="0" x2="0" y1="0" y2="1">
          <stop offset="0%" stopColor="oklch(0.55 0.18 290)" />
          <stop offset="100%" stopColor="oklch(0.75 0.13 80)" />
        </linearGradient>
      </defs>
      {/* Body */}
      <ellipse cx="32" cy="38" rx="18" ry="20" fill="url(#owl-grad)" />
      {/* Head feathers (ear tufts) */}
      <path d="M16 18 L20 8 L24 18 Z" fill="url(#owl-grad)" />
      <path d="M40 18 L44 8 L48 18 Z" fill="url(#owl-grad)" />
      {/* Eyes */}
      <circle cx="25" cy="28" r="6" fill="oklch(0.97 0.02 80)" />
      <circle cx="39" cy="28" r="6" fill="oklch(0.97 0.02 80)" />
      <circle cx="25" cy="29" r="2.6" fill="oklch(0.20 0.02 270)" />
      <circle cx="39" cy="29" r="2.6" fill="oklch(0.20 0.02 270)" />
      <circle cx="25.7" cy="28.3" r="0.8" fill="white" />
      <circle cx="39.7" cy="28.3" r="0.8" fill="white" />
      {/* Beak */}
      <path d="M30 34 L34 34 L32 39 Z" fill="oklch(0.55 0.10 50)" />
      {/* Wing hints */}
      <path d="M19 38 Q26 50 32 50" stroke="oklch(0.20 0.02 270)" strokeWidth="1" fill="none" opacity="0.4" />
      <path d="M45 38 Q38 50 32 50" stroke="oklch(0.20 0.02 270)" strokeWidth="1" fill="none" opacity="0.4" />
    </svg>
  );
}
